// extracted by mini-css-extract-plugin
export default {"StrikedPrice":"OrderItem_StrikedPrice__YqLWz","ItemDescription":"OrderItem_ItemDescription__M7Aoh"};